//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";

// custom pages
import AuthRoutes from "routes/AuthRoutes/authRoutes";
import "assets/css/custom.css";
import { authPageStyles } from "./style";

const switchComponent = AuthRoutes.map((route, i) =>
  route.redirect ? (
    <Redirect key={`AuthRoutes-${i}`} from={"/"} to={route.to} />
  ) : (
    <Route
      key={`AuthRoutes-${i}`}
      path={route.path}
      component={() => <route.component />}
    />
  )
);

export default function AuthPages() {
  const classes = authPageStyles();

  return <div className={classes.root}>{switchComponent}</div>;
}
